import router from './router'
import { getToken, setToken } from '@/utils/auth' // get token from cookie
import { getQywxAppId, login } from '@/api/auth/auth'
import store from '@/store'

router.beforeEach(async (to, from, next) => {
  const hasToken = getToken()
  const hrefIdx = window.location.href.indexOf('agentId=')
  const hrefIdx2 = window.location.href.indexOf('&code=')
  const agentid = window.location.href.slice(hrefIdx + 8, hrefIdx2)
  if (to.query.code) {
    // if (to.query.agentId) {
    if (agentid == 1000144) {
      await store.dispatch('user/Login', to.query.code)
      next({ path: '/scrm', query: {} })
    } else if (agentid == 1000145) {
      await store.dispatch('user/Login', to.query.code)
      next({ path: '/cont', query: {} })
    } else {
      await store.dispatch('user/Login', to.query.code)
      // next({path: '/', query: {}})
      next()
    }
    // } else {
    //   await store.dispatch('user/Login', to.query.code)
    //   // next({path: '/', query: {}})
    //   next()
    // }
  } else {
    if (hasToken) {
      if (store.getters.roles.length === 0) {
        await store.dispatch('user/GetInfo')
        next()
      } else {
        next()
      }
    } else {
      await store.dispatch('user/GetCode')
      next()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
})
